export function hasValue(value) {
    return value !== '' && value !== undefined && value !== null && !(Array.isArray(value) && value.length === 0);
}
//# sourceMappingURL=utils.js.map